__turbopack_context__.v({
  "cls1": "IlluCalendar-module__HQJBhG__cls1",
  "cls2": "IlluCalendar-module__HQJBhG__cls2",
});
